require('./depositRenovationCancel.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const Immutable = require('immutable')
const moment = require('moment')

// @components
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { DEPOSIT_RENOVATION_CANCEL } = require('constants/contactCenter/operationTypes');
const DepositRenovationCancelStep1 = require('./depositRenovationCancelStep1/depositRenovationCancelStep1');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const ContractSummary = require('../../../routes/contractsView/components/ContractSummary/contractSummary');

const { getLastNChars } = require('utilities/stringHelper')
const { formatInterest } = require('utilities/currencyHelper')
import { getRenovationCancelPrintedDocumentParams } from './helper/depositRenovationCancelHelper';

// @wizard
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { WIZARD_VERTICAL_VIEW_MODE, API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @helpers
const { getIsFullProfitability } = require('utilities/depositHelper')

// @constants
const {
    IDLE,
    FETCHING,
    FETCHED,
    FETCH_FAILED,
    SAVING,
    SAVED,
    SAVE_FAILED,
} = require('constants/contactCenter/depositOrImpositionCancellationStatus');

class DepositRenovationCancel extends React.Component {

    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
        this.getDetails = this.getDetails.bind(this);
        this.setDepositAndAccount = this.setDepositAndAccount.bind(this)

        this.state = { immAccount: null, immDeposit: null };
    }

    componentWillMount() {
        if (!this.props.immDeposits.has('byId')) {
            this.props.requestDeposits();
        } else {
            this.requestInformation(this.props);
            this.setDepositAndAccount(this.props)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.immDeposits.has('byId') && nextProps.immDeposits.has('byId')) {
            this.requestInformation(nextProps);
            this.setDepositAndAccount(nextProps)
        }
    }

    componentDidUpdate(prevProps) {
        const { immProfile, immDepositsRenovationCancel, immOfficePrintedDocument, fetchPdfToPrint } = this.props;
        const prevStep = prevProps.immDepositsRenovationCancel.get('currentStep');
        const currentStep = immDepositsRenovationCancel.get('currentStep');
        if (prevStep !== currentStep && currentStep === 2 && !immOfficePrintedDocument.get('document')) {
            const requestParams = getRenovationCancelPrintedDocumentParams(immProfile, immDepositsRenovationCancel, immOfficePrintedDocument);
            fetchPdfToPrint(requestParams);
       }
   }

   componentWillUnmount() {
    const { resetPdfToPrint } = this.props;
    resetPdfToPrint();
   }

   stripHtmlTags(input = '') {
    let previous;
    do {
      previous = input;
      input = input.replace(/<[^>]*>?/gm, '');
    } while (input !== previous);
    return input;
   }

    handleCancel() {
        const { history } = this.props;
        history.push('/myprofile/deposits');
    }

    onHandleGoBack() {
        const depositsPath = `/myprofile/deposits`;
        this.props.history.push(depositsPath);
    }

    buildPreleaveCancelModal() {
        const { immDepositsRenovationCancel } = this.props;
        const showCancelModal = immDepositsRenovationCancel.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    requestInformation(props) {
        const {
            match: { params: { depositId } },
            immDeposits,
            requestDepositRenovationConditions
        } = props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber'])

        requestDepositRenovationConditions(contractNumber)
    }

    setDepositAndAccount = (props) => {
        const {
            match: { params: { depositId } },
            immDeposits,
            immAccounts
        } = props

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const immAccount = immAccounts.get('byId').filter(account =>
            (account.get('contractNumber') === immDeposit.getIn(['impositionAssociatedAccount', 'contractNumber']) && 
            account.get('product') === immDeposit.getIn(['impositionAssociatedAccount', 'product']))).first()

        this.setState({ immAccount, immDeposit })
    }

    handleFinish() {
        const {
            match: { params: { depositId, accountContract } },
            immDepositsRenovationCancel,
            immDeposits,
            requestDepositRenovationToCancel
        } = this.props;
        
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const originalDepositContract = immDeposit.getIn(['contract', 'contractNumber'])

        const renovations = immDepositsRenovationCancel.get('renovations')
        const immDepositRenovationCancel = renovations
            .find(renovation => renovation.get('accountContract') === accountContract)

        const originalDepositImpositions = immDepositRenovationCancel
            .get('originalImpositions')
            .map(imposition => imposition.get('originalImpositionNumber'))

        requestDepositRenovationToCancel({
            originalDepositContract,
            originalDepositImpositions
        })
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    buildHeader() {
        return (
            <OKCover size="small" section="deposits">
                <OKHeaderLanding title={formatText('deposits-title')} inputClassName="ok-header-landing--deposits" />
            </OKCover>
        );
    }

    buildLoading() {
        return (
            <OKSectionBox className="imposition-early-cancel-view__content">
                <LoadingSection />
            </OKSectionBox>
        );
    }

    buildWizard() {
        const {
            match: { params: { accountContract } },
            immDepositsRenovationCancel,
            immProfile,
            setVisibleStep,
            validateStep,
            immOfficePrintedDocument,
            originCountry,
        } = this.props;
        const { immDeposit, immAccount } = this.state

        if (!immDeposit || !immAccount) { return null }
        const currentStep = immDepositsRenovationCancel.get('currentStep');
        const immSteps = immDepositsRenovationCancel.get('steps');
        const immDepositRenovationCancel = immDepositsRenovationCancel.get('renovations')
            .find(renovation => renovation.get('accountContract') === accountContract)

        const actions = {
            setVisibleStep,
            validateStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleShowCancelModal
        };

        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + immDeposit.getIn(['impositionAssociatedAccount', 'product']) + immDeposit.getIn(['impositionAssociatedAccount', 'contractNumber'])

        const operationParams = {
            originAccount
        };
        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={3}
                visibleStep={currentStep}
                wizardClass="deposits-renovations-cancel__wizard"
            >
                <WizardStep
                    position="first"
                    cancelButton
                >
                    <DepositRenovationCancelStep1
                        immAccount={immAccount}
                        immDepositRenovationCancel={immDepositRenovationCancel}
                        immProfile={immProfile}
                        immDeposit={immDeposit}
                        originCountry={originCountry}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton
                    cancelButton
                    addLoadingBehaviour
                    isLoading={false}
                    immFinalButton="common-confirm"
                >
                    <VerifyOtpStep
                        operationType={DEPOSIT_RENOVATION_CANCEL}
                        operationParams={operationParams}
                        withValidateButton={false}
                        pdfToShow={immOfficePrintedDocument.get('document')}
                        isPdfToShowBase64={false}
                        pdfToShowFetching={immOfficePrintedDocument.get('isFetching')}
                        pdfToShowError={immOfficePrintedDocument.get('error')}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildSuccessfulFeedback() {
        const { immProfile } = this.props

        const mainButton = {
            label: formatText('cancelImposition-feedbackBackButton'),
            url: '/myprofile/deposits/'
        };

        const { immAccount } = this.state

        const successWizardRequired = Immutable.fromJS({ state: { card_details: [] } })

        return (
            <WizardSuccess
                successMessage={formatText('contractsView-contractsView_depositRenovationCancelSuccessTitle')}
                mainButton={mainButton}
            >
                <ContractSummary
                    immAccount={immAccount}
                    immProfileFields={immProfile}
                    details={this.getDetails()}
                    wizardState={successWizardRequired}
                    warningMessage={[]}
                />
            </WizardSuccess>
        );
    }

    setDetail = ({ title, value, usePrefix = true }) => ({
        columns: 12,
        title: usePrefix ? formatText(`contractsView-contractsView_${title}`) : title,
        body: value,
    })

    getFullDate = (date) => {
        return moment(date).locale(getLanguage()).format('LL')
    }

    getDetails = () => {
        const {
            match: { params: { accountContract } },
            immDepositsRenovationCancel,
            originCountry
        } = this.props

        const { immAccount, immDeposit } = this.state

        const immDepositRenovationCancel = immDepositsRenovationCancel.get('renovations')
            .find(renovation => renovation.get('accountContract') === accountContract)
            .toJS()

        const sharedImpositionData = immDepositRenovationCancel.originalImpositions[0]

        const sumImpositions = immDepositRenovationCancel.originalImpositions
            .reduce((amount, renewal) => amount + renewal.renewalAmount, 0)

        const plainAmountObject = getPlainAmountObject({
            amount: sumImpositions,
            currency: immDeposit.getIn(['amount', 'currency'])
        });

        const showFullValues = getIsFullProfitability(originCountry)

        const { amount, currencySymbol } = formatAmountObject(plainAmountObject, true)
        const fullAmount = `${amount} ${currencySymbol}`

        const accountAlias = immAccount.get('alias')
        const shortIban = getLastNChars(immAccount.get('iban'), 4)

        const tin = formatInterest(sharedImpositionData.renewalTin)
        const tae = formatInterest(sharedImpositionData.renewalTae)

        const isSameTinTae = tin === tae

        const injectedProfitabilityStrings = [
            ...(showFullValues && !isSameTinTae ? [tin] : []),
            tae
        ]

        const profitabilityFullValue = isSameTinTae
              ? 'contractsView-contractsView_ccDepositConditionProfitabilitySameTinTaeValues'
              : 'contractsView-contractsView_ccDepositConditionProfitabilityValues'

        const profiabilityKey = showFullValues
            ? profitabilityFullValue
            : 'contractsView-contractsView_ccDepositConditionProfitabilityValuesSimple'

        const profiabilityValues = this.stripHtmlTags(formatText(profiabilityKey, injectedProfitabilityStrings));

        return [
            [
                {
                    className: 'contract-summary__border-separator',
                    columns: 6,
                    details: [
                        this.setDetail({ title: 'depositRenewalCancellationProduct', value: 'contractsView-depositNMProductName' }),
                        this.setDetail({ title: 'depositRenewalCancellationAmount', value: fullAmount }),
                        this.setDetail({ title: 'depositRenewalCancellationAccount', value: `${accountAlias} ${shortIban}` }),
                        this.setDetail({ 
                            title: 'depositRenewalCancellationApplicationDate',
                            value: this.getFullDate(sharedImpositionData.requestDate)
                        }),
                        this.setDetail({ 
                            title: 'depositRenewalCancellationInterestLiquidation',
                            value: 'contractsView-contractsView_ccDepositConditionInterestLiquidationType'
                        })
                    ]
                },
                {
                    columns: 5,
                    offset: 1,
                    details: [
                        this.setDetail({ title: 'depositRenewalCancellationTime', value: formatText('contractsView-installmentValueKey', [immDepositRenovationCancel.renewalDepositTermValue]) }),
                        this.setDetail({ title: 'depositRenewalCancellationProfitability', value: profiabilityValues }),
                        this.setDetail({ 
                            title: 'contractSummary-automaticRenewal',
                            usePrefix: false,
                            value: 'contractSummary-mainDepositNo'
                        }),
                        this.setDetail({ title: 'depositRenewalCancellationStartDate', value: this.getFullDate(sharedImpositionData.originalImpositionExpirationDate) })
                    ]
                }
            ]
        ]
    }

    buildErrorFeedback() {
        const mainButton = {
            label: formatText('cancelImposition-feedbackBackButton'),
            url: '/myprofile/deposits/'
        };

        return (
            <WizardError
                errorMessage={formatText('contractsView-contractsView_depositRenovationCancelFailureTitle')}
                mainButton={mainButton}
            >
                <div className="account-direct-debit-partial-success__content">
                    <FormattedText value="contractsView-contractsView_depositRenovationCancelFailureText"/>
                </div>
            </WizardError>
        )
    }

    render() {
        const { immDepositsRenovationCancel } = this.props;
        const status = immDepositsRenovationCancel.get('status');

        const header = this.buildHeader();
        let content;

        switch (status) {
            case IDLE:
            case FETCHING:
                content = this.buildLoading();
                break;
            case FETCHED:
            case SAVING:
                const wizard = this.buildWizard();
                const preleaveCancelModal = this.buildPreleaveCancelModal();
                content = (
                    <div>
                        {wizard}
                        {preleaveCancelModal}
                    </div>
                );
                break;
            case FETCH_FAILED:
                content = this.buildErrorFeedback();
                break;
            case SAVED:
                content = this.buildSuccessfulFeedback();
                break;
            case SAVE_FAILED:
                content = this.buildErrorFeedback();
                break;
        }

        return (
            <div className="deposits-renovations-cancel">
                {header}
                <div className="deposits-renovations-cancel__body">
                    {content}
                </div>
            </div>
        );
    }
}

DepositRenovationCancel.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immDepositsRenovationCancel: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    fetchPdfToPrint: PropTypes.func.isRequired,
    requestDepositRenovationConditions: PropTypes.func.isRequired,
    requestDepositRenovationToCancel: PropTypes.func.isRequired,
    immOfficePrintedDocument: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    resetPdfToPrint: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    originCountry: PropTypes.func.isRequired,
};


module.exports = withRouter(DepositRenovationCancel);
